var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"shio-upload-button",attrs:{"disabled":!_vm.pickerApiLoaded,"depressed":""},on:{"click":_vm.handleButtonClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }